var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "5px",
    viewBox: "0 0 8 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "caret-down-symbol",
    transform: "translate(-8.000000, -10.000000)",
    fill: "#899CB7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5940275,10.1800739 C11.8202314,9.93997538 12.1797229,9.93997538 12.4059268,10.1800739 L15.8364875,13.935852 C15.9966488,14.1146898 16.0440224,14.3808311 15.9569185,14.6124232 C15.8698145,14.8440152 15.6650024,14.9964712 15.4362554,15.0000107 L8.57513412,15.0000107 C8.34430957,15.0014736 8.13531035,14.8508592 8.04528876,14.6181583 C7.95526716,14.3854575 8.00188289,14.1163195 8.16346684,13.935852 L11.5940275,10.1800739 Z",
    id: "caret-down",
    transform: "translate(12.000000, 12.500005) rotate(-180.000000) translate(-12.000000, -12.500005) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.e801d06e519474aa65df13dbbeb56ab2.svg";
export { ForwardRef as ReactComponent };